export default __webpack_public_path__ + "static/cd_raw_1-012250444ad3803e3b7736905c1aa4c4.jpg";